export const style = {
  addressField: {
    // width: '35%',
  },
};
